var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-45.517H0V385.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621V256h512V126.621 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 83.86
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M246.788,260.953l64.48-55.268v79.987c0,13.481-10.929,24.408-24.408,24.408l0,0 c-6.03,0-11.847-2.232-16.329-6.265l-23.743-21.368L246.788,260.953L246.788,260.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M280.801,292.404l-18.66-16.794v-27.815l33.775-28.95v20.221v46.607c0,4.994-4.063,9.056-9.056,9.056 C284.619,294.729,282.467,293.903,280.801,292.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M271.352,239.9v31.617l15.352,13.862v-46.505v-12.131l9.212-7.896v20.221v46.607 c0,4.994-4.063,9.056-9.056,9.056c-2.241,0-4.393-0.825-6.059-2.325l-18.66-16.794v-27.815L271.352,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M265.212,260.953l-64.48-55.268v79.987c0,13.481,10.929,24.408,24.408,24.408l0,0 c6.03,0,11.847-2.232,16.329-6.265l23.743-21.368V260.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M231.199,292.404l18.66-16.794v-27.815l-33.775-28.95v20.221v46.607c0,4.994,4.063,9.056,9.056,9.056 C227.381,294.729,229.533,293.903,231.199,292.404z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M240.648,239.9v31.617l-15.352,13.862v-46.505v-12.131l-9.212-7.896v20.221v46.607 c0,4.994,4.063,9.056,9.056,9.056c2.241,0,4.393-0.825,6.059-2.325l18.66-16.794v-27.815L240.648,239.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.04,
    y: 205.96,
    style: {
      fill: "#41479B"
    },
    width: 4.414,
    height: 26.449
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.51,
    y: 205.96,
    style: {
      fill: "#41479B"
    },
    width: 4.414,
    height: 26.449
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4646"
    },
    d: "M246.788,193.404c0,0,6.141-29.17-15.352-25.331c-21.493,3.838-21.493,9.978-46.057,22.261 c0,0,27.635,6.141,39.916,3.071c0,0,9.212,12.281,18.423,15.352h9.212L246.788,193.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4646"
    },
    d: "M265.212,193.404c0,0-6.141-29.17,15.352-25.331c21.493,3.838,21.493,9.978,46.057,22.261 c0,0-27.635,6.141-39.916,3.071c0,0-9.212,12.281-18.423,15.352h-9.212L265.212,193.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4646"
    },
    d: "M265.212,208.756h-18.423V193.29c0-5.025,4.073-9.098,9.098-9.098h0.226 c5.025,0,9.098,4.073,9.098,9.098v15.466L265.212,208.756L265.212,208.756z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E1CD"
    },
    cx: 256,
    cy: 193.4,
    r: 6.141
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD0AF"
    },
    d: "M242.823,189.438l11.546,6.166c0.969,0.518,2.162,0.34,2.937-0.437l0,0 c0.974-0.974,0.974-2.552,0-3.527l-7.448-7.448h-1.791C245.171,184.192,242.823,186.54,242.823,189.438L242.823,189.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF94"
    },
    d: "M246.827,190.333h-9.249l4.047-4.738c0.76-0.89,1.871-1.402,3.042-1.402h5.192v3.108 C249.859,188.975,248.501,190.333,246.827,190.333z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB400"
    },
    d: "M282.186,208.764c-2.072-2.458-2.514-5.717-1.504-8.541c2.954-0.516,6.091,0.471,8.162,2.931 c1.77,2.101,2.283,4.772,1.784,7.272c0.614,1.042,1.364,2.382,2.189,3.964c0.041-0.225,0.032-0.448,0.096-0.673 c0.724-2.546,2.743-4.348,5.135-4.958c1.713,1.778,2.483,4.373,1.759,6.918c-0.622,2.19-2.227,3.777-4.18,4.581 c0.771,1.769,1.534,3.677,2.247,5.69c0.041-0.118,0.044-0.238,0.092-0.355c1-2.451,3.206-4.019,5.65-4.362 c1.506,1.955,1.986,4.619,0.987,7.07c-0.875,2.144-2.69,3.558-4.764,4.121c1.067,4.213,1.775,8.683,1.775,13.183h-3.071 c0-3.922-0.602-7.85-1.511-11.608c-1.895,0.612-4.012,0.481-5.845-0.641c-2.236-1.37-3.416-3.778-3.361-6.223 c2.154-1.16,4.835-1.203,7.071,0.168c0.081,0.05,0.135,0.121,0.213,0.173c-0.658-1.89-1.358-3.683-2.077-5.365 c-1.843,0.871-4.012,1.005-6.002,0.071c-2.374-1.114-3.811-3.379-4.026-5.815c2.006-1.386,4.657-1.722,7.023-0.62 c-0.846-1.625-1.608-2.985-2.206-4.002C285.707,211.499,283.67,210.525,282.186,208.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB400"
    },
    d: "M229.814,208.764c2.071-2.458,2.514-5.717,1.504-8.541c-2.954-0.516-6.091,0.471-8.162,2.931 c-1.77,2.101-2.283,4.772-1.784,7.272c-0.614,1.042-1.364,2.382-2.189,3.964c-0.041-0.225-0.032-0.448-0.096-0.673 c-0.724-2.546-2.743-4.348-5.135-4.958c-1.713,1.778-2.483,4.373-1.759,6.918c0.622,2.19,2.227,3.777,4.18,4.581 c-0.771,1.769-1.534,3.677-2.247,5.69c-0.041-0.118-0.044-0.238-0.092-0.355c-1-2.451-3.206-4.019-5.65-4.362 c-1.506,1.955-1.986,4.619-0.986,7.07c0.875,2.144,2.69,3.558,4.764,4.121c-1.067,4.213-1.775,8.683-1.775,13.183h3.071 c0-3.922,0.602-7.85,1.511-11.608c1.895,0.612,4.012,0.481,5.844-0.641c2.237-1.37,3.416-3.778,3.361-6.223 c-2.154-1.16-4.835-1.203-7.071,0.168c-0.081,0.05-0.135,0.121-0.213,0.173c0.658-1.89,1.358-3.683,2.077-5.365 c1.843,0.871,4.012,1.005,6.002,0.071c2.374-1.114,3.811-3.379,4.026-5.815c-2.006-1.386-4.657-1.722-7.023-0.62 c0.845-1.625,1.608-2.985,2.206-4.002C226.293,211.499,228.33,210.525,229.814,208.764z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,276.306l-64.48-55.268v79.987c0,13.481,10.929,24.408,24.408,24.408l0,0 c6.03,0,11.847-2.232,16.329-6.265L256,297.8V276.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M221.987,307.756l18.66-16.794v-27.815l-33.775-28.95v20.221v46.607c0,4.994,4.063,9.056,9.056,9.056 C218.17,310.081,220.321,309.256,221.987,307.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M231.436,255.252v31.617l-15.352,13.862v-46.505v-12.132l-9.212-7.896v20.221v46.607 c0,4.994,4.063,9.056,9.056,9.056c2.241,0,4.393-0.825,6.059-2.325l18.66-16.794v-27.815L231.436,255.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,276.306l64.48-55.268v79.987c0,13.481-10.929,24.408-24.408,24.408l0,0 c-6.03,0-11.847-2.232-16.329-6.265L256,297.8V276.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M290.013,307.756l-18.66-16.794v-27.815l33.775-28.95v20.221v46.607c0,4.994-4.063,9.056-9.056,9.056 C293.831,310.081,291.679,309.256,290.013,307.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M280.564,255.252v31.617l15.352,13.862v-46.505v-12.132l9.212-7.896v20.221v46.607 c0,4.994-4.063,9.056-9.056,9.056c-2.241,0-4.393-0.825-6.059-2.325l-18.66-16.794v-27.815L280.564,255.252z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#69C3FF"
    },
    cx: 256,
    cy: 254.81,
    rx: 30.705,
    ry: 46.06
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009B64"
    },
    d: "M228.365,267.095h55.268l3.071-12.281l-13.993,2.333c-2.807,0.468-5.678-0.332-7.839-2.184 l-15.884-13.615c-1.419-1.216-3.228-1.886-5.097-1.886l0,0c-2.077,0-4.07,0.825-5.538,2.294l-9.988,9.988V267.095L228.365,267.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M253.087,252.75l5.274-3.37l-9.374-8.034c-1.419-1.216-3.228-1.886-5.097-1.886l0,0 c-2.077,0-4.07,0.825-5.538,2.294l-9.988,9.988v3.071l15.352-3.071l2.714,1.357C248.557,254.163,251.085,254.029,253.087,252.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5AA0E6"
    },
    points: "228.365,267.095 231.436,285.517 246.788,300.87 256,300.87 268.281,297.8 280.564,285.517  283.634,267.095 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC88C"
    },
    d: "M256,303.94c-18.624,0-33.775-22.039-33.775-49.128s15.151-49.128,33.775-49.128 s33.775,22.039,33.775,49.128S274.624,303.94,256,303.94z M256,211.827c-15.236,0-27.635,19.284-27.635,42.986 S240.762,297.8,256,297.8s27.634-19.284,27.634-42.987S271.236,211.827,256,211.827z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E1E1"
    },
    d: "M234.339,300.595c-2.574-3.554-6.406-5.865-10.746-5.865s-8.172,2.311-10.746,5.865 c4.39,1.217,7.982,4.781,9.683,9.479c0.685,1.892,1.064,3.968,1.064,6.15C223.593,308.627,228.182,302.301,234.339,300.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E1E1"
    },
    d: "M226.031,310.281c0,0-0.241,4.094-2.339,6.013l-0.088-0.072c-2.099-1.919-2.339-6.013-2.339-6.013 L226.031,310.281z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M294.4,311.616h-76.8c-0.838,0-1.516-0.679-1.516-1.516v-0.038c0-0.838,0.679-1.516,1.516-1.516h76.8 c0.838,0,1.516,0.679,1.516,1.516v0.038C295.916,310.937,295.238,311.616,294.4,311.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE915A"
    },
    d: "M271.427,316.222h-30.856c-3.35,0-6.066-2.716-6.066-6.066v-0.151c0-3.35,2.716-6.066,6.066-6.066 h30.856c3.35,0,6.066,2.716,6.066,6.066v0.151C277.493,313.506,274.777,316.222,271.427,316.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M228.365,308.546h-10.746c-0.847,0-1.535,0.687-1.535,1.535s0.687,1.535,1.535,1.535h10.746V308.546z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,316.222 256,344.276 243.719,340.786 249.859,316.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "252.929,316.222 246.788,337.716 234.507,334.645 243.719,316.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "240.648,316.222 231.436,328.504 240.648,331.574 246.788,316.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,316.222 256,344.276 268.281,340.786 262.141,316.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "259.071,316.222 265.212,337.716 277.493,334.645 268.281,316.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "271.352,316.222 280.564,328.504 271.352,331.574 265.212,316.222 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "193.728,247.482 189.314,243.034 189.314,221.035 193.728,221.035  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "322.646,243.034 318.232,247.482 318.232,221.035 322.646,221.035  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.b7d4536afded12ee4258e41e8f8c550f.svg";
export { ForwardRef as ReactComponent };